// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/hints/HintSystem.css */

.hint-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: hintFadeIn 0.2s ease-out;
}

/* Переопределяем базовый mafia-generic-card для режима подсказки */
.hint-card {
  width: 90%;
  max-width: 360px;
  min-height: auto; /* Позволяем сжиматься */
  display: flex;
  flex-direction: column;
  position: relative;
  /* Убираем анимацию из MafiaOverlay.css, если она мешает или дублируется */
  animation: hintScaleIn 0.25s cubic-bezier(0.18, 0.89, 0.32, 1.28) !important;
}

.hint-body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.hint-header-fix {
  padding: 0px !important;
}

.hint-card-img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  margin-bottom: 15px;
  object-fit: contain;
  border: 1px solid rgba(0,0,0,0.05);
}

.hint-card-text {
  font-size: 16px;
  line-height: 1.5;
  text-align: left;
  /* mpc-content обычно не имеет цвета текста, поэтому берем из темы или дефолт */
}


/* Стили для мини-подсказки (она игнорирует некоторые части темы для компактности) */
.hint-mini-tooltip {
  position: absolute;
  max-width: 220px;
  padding: 12px 16px;
  min-height: auto;
}

.hint-mini-tooltip .hint-body { padding: 0; }
.hint-mini-tooltip .hint-card-text { text-align: left; font-size: 13px; }

@keyframes hintFadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes hintScaleIn { from { transform: scale(0.9); opacity: 0; } to { transform: scale(1); opacity: 1; } }`, "",{"version":3,"sources":["webpack://./src/components/hints/HintSystem.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,WAAW,EAAE,YAAY;EAC1C,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA,mEAAmE;AACnE;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB,EAAE,wBAAwB;EAC1C,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,0EAA0E;EAC1E,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,+EAA+E;AACjF;;;AAGA,oFAAoF;AACpF;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,gCAAgC,UAAU,EAAE;AAC5C,qCAAqC,gBAAgB,EAAE,eAAe,EAAE;;AAExE,wBAAwB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;AAChE,yBAAyB,OAAO,qBAAqB,EAAE,UAAU,EAAE,EAAE,KAAK,mBAAmB,EAAE,UAAU,EAAE,EAAE","sourcesContent":["/* src/components/hints/HintSystem.css */\r\n\r\n.hint-overlay {\r\n  position: fixed;\r\n  top: 0; left: 0; width: 100%; height: 100%;\r\n  z-index: 9999;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  animation: hintFadeIn 0.2s ease-out;\r\n}\r\n\r\n/* Переопределяем базовый mafia-generic-card для режима подсказки */\r\n.hint-card {\r\n  width: 90%;\r\n  max-width: 360px;\r\n  min-height: auto; /* Позволяем сжиматься */\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: relative;\r\n  /* Убираем анимацию из MafiaOverlay.css, если она мешает или дублируется */\r\n  animation: hintScaleIn 0.25s cubic-bezier(0.18, 0.89, 0.32, 1.28) !important;\r\n}\r\n\r\n.hint-body {\r\n  padding: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.hint-header-fix {\r\n  padding: 0px !important;\r\n}\r\n\r\n.hint-card-img {\r\n  width: 100%;\r\n  height: auto;\r\n  border-radius: 8px;\r\n  margin-bottom: 15px;\r\n  object-fit: contain;\r\n  border: 1px solid rgba(0,0,0,0.05);\r\n}\r\n\r\n.hint-card-text {\r\n  font-size: 16px;\r\n  line-height: 1.5;\r\n  text-align: left;\r\n  /* mpc-content обычно не имеет цвета текста, поэтому берем из темы или дефолт */\r\n}\r\n\r\n\r\n/* Стили для мини-подсказки (она игнорирует некоторые части темы для компактности) */\r\n.hint-mini-tooltip {\r\n  position: absolute;\r\n  max-width: 220px;\r\n  padding: 12px 16px;\r\n  min-height: auto;\r\n}\r\n\r\n.hint-mini-tooltip .hint-body { padding: 0; }\r\n.hint-mini-tooltip .hint-card-text { text-align: left; font-size: 13px; }\r\n\r\n@keyframes hintFadeIn { from { opacity: 0; } to { opacity: 1; } }\r\n@keyframes hintScaleIn { from { transform: scale(0.9); opacity: 0; } to { transform: scale(1); opacity: 1; } }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
